export default "__VITE_ASSET__0e5e5069__"